import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  z-index: 1;
`;

export const Box = styled.div`
  min-height: 40px;
  width: 342px;
  border-radius: 5px;
  background-color: #9d2e58;
  box-shadow:
    0 19px 60px rgba(0, 0, 0, 0.3),
    0 15px 20px rgba(0, 0, 0, 0.22);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Pointer = styled.div`
  display: ${props => (props.noArrow ? 'none' : 'block')};
  position: absolute;
  bottom: -42px;
  right: ${props => (props.left ? '279px' : '13px')};
  width: 0px;
  height: 0px;
  border-left: 26px solid transparent;
  border-right: 26px solid transparent;
  border-top: 48px solid #9d2e58;
`;
